module.exports = __webpack_public_path__ + "img/delivery-man.9ff9a78c.png";